export default __webpack_public_path__ + "static/media/SWT0820.34I-40902_-24205_0.116b05c9.jpg";